import { Component, Injector, Input, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { SubjectManager } from '../../../../../../common/js/subjectManager/SubjectManager';

import { BaseFormComponent } from '../base-form.component';
import { CoverpathControllerInterface } from '../../../../interfaces/controller/CoverpathControllerInterface';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';

@Component({
  moduleId: module.id,
  selector: 'custom-waiver',
  templateUrl: './custom-waiver.component.html',
})
export class CustomWaiverComponent extends BaseFormComponent implements OnInit {
  @Input() property: string;
  @Input() showTitle: boolean;
  @ViewChild('questionLabel') questionLabel;
  selectedItem: string;
  options: Array<any>;
  radioGroupName: string;
  controller: CoverpathControllerInterface;

  constructor(protected injector: Injector, private amorphicService: AmorphicService) {
    super(injector);
    this.controller = this.amorphicService.controller;
    this.showTitle = true;
  }

  ngOnInit() {
    if (!this.property) {
      this.property = this.questionItem.prop;
      this.property = this.handleIterate(this.property);
    }

    this.radioGroupName = this.loopIndex > 0 ? this.questionItem.fid + this.loopIndex : this.questionItem.fid;

    super.ngOnInit();

    //if an option is removed from a property and database still holds value which is already removed, it resets the component value and also database
    //do it only if there is responses allowed, as it signifies that option was removed recently
    const selectedItem = this.selectedItem;
    if (
      this.questionItem.responsesAllowed &&
      this.options &&
      this.options.filter((option) => option.value === selectedItem).length === 0
    ) {
      this.resetValue();
      this.resetNode();
      this.enableNestedControls();
    }

    this.updateFromModel();
  }

  updateFromModel() {
    this.cdRef.detectChanges();

    this.setOptions();
    const value = this.getValue(this.property) + '';
    this.selectedItem = value;
    this.enableNestedControls();
  }

  setOptions() {
    const prop = this.property;
    const values: any = this.getValuesFor(prop);
    const descriptionsObj = this.getDescriptionsFor(prop);
    if (!this.areOptionsDifferent(values)) {
      return;
    }

    if (this.options) {
      this.options.length = 0;
    } else {
      this.options = [];
    }

    values.forEach((val) => {
      const description = typeof descriptionsObj[val] === 'object' ? descriptionsObj[val].text : descriptionsObj[val];
      this.options.push({
        value: val,
        description: description,
      });
    });
  }

  private areOptionsDifferent(values) {
    if (!this.options || !values) {
      return true;
    }
    if (this.options.length !== values.length) {
      return true;
    }
    let ret = false;
    for (let i = 0; i < this.options.length; i++) {
      ret = ret || this.options[i].value !== values[i];
    }
    return ret;
  }

  getModifierClasses() {
    const classNames = [];
    const vertical = this.questionItem.controlType === 'radio-group-vertical';

    if (vertical) {
      classNames.push('radio-group--vertical');
    } else {
      classNames.push('radio-group--inline');
    }

    if (this.isDisabled) {
      classNames.push('radio-group--disabled');
    }

    return classNames.join(' ');
  }

  enableNestedControls() {
    // find which radio is a text input and remove the __ marking it
    if (
      this.questionItem.controlType === 'radio-group-with-text' ||
      this.questionItem.controlType === 'radio-group-with-text-date'
    ) {
      this.options.forEach((option) => {
        option.isEnabled = option.value === this.selectedItem;
        if (option.description.indexOf('__ Date') !== -1) {
          option.description = option.description.replace('__ Date', '');
          option.isDateInput = true;
        } else if (option.description.indexOf('__') !== -1) {
          const descriptionArr = option.description.split('__');
          // check if theres text before and after the text input
          if (descriptionArr.length === 2) {
            option.beforeInputDescription = descriptionArr[0];
            option.description = descriptionArr[1];
            option.extraClasses = ['small', 'input-sandwich'];
            option.isSandwich = true;
          } else {
            option.beforeInputDescription = descriptionArr[0];
            option.extraClasses = ['small'];
          }

          option.isTextInput = true;
        }
      });
    }
  }

  resetValue() {
    this.selectedItem = '';
  }

  async trigger() {
    // owner/insured questions are changed, make sure Please Acknowledge section is updated before section check
    if (this.questionItem.prop.includes('insuredType') || this.questionItem.prop.includes('ownerType')) {
      this.controller.customer.application.insuredHasAcknowledged = false;
      this.controller.customer.application.ownerHasAcknowledged = false;
      this.controller.customer.application.otherOwnerHasAcknowledged = false;
    }

    await this.validateAndSet(this.property, this.selectedItem);
    this.enableNestedControls();
  }
}
